import type { DeleteIssueUpdatesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteIssueUpdatesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteIssueUpdates = createMutationHook({
  name: 'deleteIssueUpdates',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.issueUpdate.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: { ids: string[] }) => ({ ids: variables.ids }),
  invalidate: (trpc) => [trpc.frontend.issueUpdate.register.queryKey()],
  mapResponse: (result: {
    affected_rows: number;
  }): DeleteIssueUpdatesMutation => ({
    delete_issue_update: {
      __typename: 'issue_update_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: DeleteIssueUpdatesDocument,
  graphqlVariables: (variables: { ids: string[] }) => ({
    Ids: variables.ids,
  }),
  evictFields: ['issue_update'],
});
